import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment';

const DateTitle = React.memo(({ style, intl, date, className, numberOfItems }) => {
  const dateFormats = intl.messages.date_formats;
  const t = intl.messages.containers.Jobs;
  const component = (
    <div className={className}>
      <h2 className="title">{moment(date).calendar(null, dateFormats.table_calendar)} </h2>
      {!!numberOfItems && (
        <div>
          (
          <FormattedMessage
            id={t.number_of_jobs}
            defaultMessage={t.number_of_jobs}
            values={{
              number: String(numberOfItems),
            }}
          />
          )
        </div>
      )}
    </div>
  );

  if (!style) {
    return component;
  }

  return <div style={style}>{component}</div>;
});

DateTitle.propTypes = {
  intl: PropTypes.object,
  date: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  numberOfItems: PropTypes.number.isRequired,
  style: PropTypes.shape({}),
};

DateTitle.defaultProps = {};

export default DateTitle;
